module.exports = __webpack_public_path__ + "img/integralTask_draw_bg.21c26088.png";